export const legacy = process.env.NEXT_PUBLIC_AVCAN_API_URL_LEGACY
export const api = process.env.NEXT_PUBLIC_AVCAN_API_URL
export const ast = process.env.NEXT_PUBLIC_AST_API_URL
export const weather = process.env.NEXT_PUBLIC_WEATHER_API_URL
export const incidents = process.env.NEXT_PUBLIC_INCIDENTS_API_URL
export const key = process.env.NEXT_PUBLIC_AVCAN_API_KEY
